// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 660) return "content/plugin-plotly-chart/16865a224452ce8f33fc99ef3df08272.js";
	// return url for filenames based on template
	return undefined;
};